import Lottie from "lottie-react";
import LoadingAnimation from "../assets/js/lotty-animation";
const PageLoader = () => (
  <div className="d-flex flex-column justify-content-center align-items-center text-center" style={{ minHeight: "60vh" }} >
    <Lottie animationData={LoadingAnimation} loop style={{ width: 280, maxWidth: "90%" }} />
    <h5 className="mt-3 fw-semibold">
      Finding the best colleges for you...
    </h5>
    <p className="text-muted">
      Please wait while we prepare your learning journey
    </p>
  </div>
);
export default PageLoader;